import React from 'react';
import styles from './Facilities.module.css';

export const SportTag = ({ name, isActive, onClick }) => (
  <div 
    className={isActive ? styles.activeTag : styles.sportTag}
    onClick={onClick}
    style={{ cursor: 'pointer' }}
  >
    {name}
  </div>
);